export default __webpack_public_path__ + "static/media/gtc-office.53da09c6.jpg";